import {
  DashboardColumn,
  DashboardRow,
  DashboardTab,
  DashboardWidget,
  WidgetType
} from './home-dashboard.models';

export type DashboardRenderType = 'bar' | 'line' | 'area' | 'pie' | 'card' | 'actions' | 'unknown';

export function extractWidgetNames(tabs: DashboardTab[]): string[] {
  const widgetNames = new Set<string>();

  for (const tab of tabs || []) {
    traverseDashboardRows(tab.rows, column => {
      if (column?.content?.type === 0 && column.content.ref) {
        widgetNames.add(column.content.ref);
      }
    });
  }

  return Array.from(widgetNames);
}

export function selectVisibleWidgetNames(widgetNames: string[], visibleWidgetNames: Set<string>): string[] {
  return (widgetNames || []).filter(widgetName => visibleWidgetNames.has(widgetName));
}

export function getWidgetRenderType(widgetType: WidgetType): DashboardRenderType {
  switch (widgetType) {
    case WidgetType.ChartBar:
      return 'bar';
    case WidgetType.ChartLine:
      return 'line';
    case WidgetType.ChartArea:
      return 'area';
    case WidgetType.ChartPie:
      return 'pie';
    case WidgetType.ChartCard:
      return 'card';
    case WidgetType.Actions:
      return 'actions';
    default:
      return 'unknown';
  }
}

export function getWidgetDataArray(data: any): Array<Record<string, any>> {
  if (Array.isArray(data)) {
    return data.filter(item => !!item);
  }

  if (data === null || data === undefined) {
    return [];
  }

  return [data];
}

function traverseDashboardRows(rows: DashboardRow[], visitor: (column: DashboardColumn) => void) {
  (rows || []).forEach(row => {
    (row?.columns || []).forEach(column => {
      visitor(column);

      if (column?.rows?.length) {
        traverseDashboardRows(column.rows, visitor);
      }
    });
  });
}
